import { Tour, TourStep } from '../models/tour.model';
import { DASHBOARD_TOUR } from './tours/dashboard.tour';
import { DEAL_FILTER_TOUR } from './tours/deal-filter.tour';
import { DEAL_PAGE_TOUR } from './tours/deal-page.tour';
import { MARKET_COMPARE_TOUR } from './tours/market-compare.tour';
import { NOTE_ACTIONS_TOUR } from './tours/note-actions.tour';
import { NOTE_BLOCK_TOUR } from './tours/note-block.tour';
import { NOTES_PAGE_TOUR } from './tours/notes-page.tour';
import { TERM_EXPLORER_TOUR } from './tours/term-explorer.tour';
import { TEXT_SEARCH_TOUR } from './tours/text-search.tour';

export const DEFAULT_STEPS: TourStep[] = [
  {
    title: 'Welcome to Semeris Docs',
    intro: `EXAMPLE`,
  },
];

export const GUIDED_TOURS: Tour[] = [
  // Basics
  {
    id: 'dashboard',
    steps: DASHBOARD_TOUR,
  },
  {
    id: 'deal-filter',
    steps: DEAL_FILTER_TOUR,
  },
  {
    id: 'text-search',
    steps: TEXT_SEARCH_TOUR,
  },
  {
    id: 'market-compare',
    steps: MARKET_COMPARE_TOUR,
  },

  // Deal
  {
    id: 'deal-page',
    steps: DEAL_PAGE_TOUR,
  },
  {
    id: 'term-explorer',
    steps: TERM_EXPLORER_TOUR,
  },

  // Notes
  {
    id: 'note-block',
    steps: NOTE_BLOCK_TOUR,
  },
  {
    id: 'note-actions',
    steps: NOTE_ACTIONS_TOUR,
  },
  {
    id: 'notes-page',
    steps: NOTES_PAGE_TOUR,
  },
];
